// extracted by mini-css-extract-plugin
export default {"dashboard__header":"Dashboard_dashboard__header__mvlin","dashboard__content":"Dashboard_dashboard__content__bEsY3","dashboard--empty":"Dashboard_dashboard--empty__ZVk2n"};